"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.totalReducer = exports.sortByValueNumeric = exports.sortByValue = exports.shorten = exports.setPrecision = exports.indexIntoObj = exports.ifUndefined = exports.dotIndex = void 0;
var ifUndefined = exports.ifUndefined = function ifUndefined(value, alt) {
  return typeof value === 'undefined' ? alt : value;
};
var sortByValue = exports.sortByValue = function sortByValue(value) {
  return function (a, b) {
    var aValue = dotIndex(value, a);
    var bValue = dotIndex(value, b);
    if (aValue > bValue) {
      return -1;
    }
    if (aValue < bValue) {
      return 1;
    }
    return 0;
  };
};
var sortByValueNumeric = exports.sortByValueNumeric = function sortByValueNumeric(value) {
  return function (a, b) {
    var aValue = dotIndex(value, a);
    var bValue = dotIndex(value, b);
    return bValue - aValue;
  };
};
var dotIndex = exports.dotIndex = function dotIndex(idx, obj) {
  return indexIntoObj(idx.split('.'), obj);
};
var indexIntoObj = exports.indexIntoObj = function indexIntoObj(idx, obj) {
  if (obj === undefined) {
    return undefined;
  }
  if (idx.length === 1) {
    return obj[idx[0]];
  }
  var newIndex = idx;
  var first = newIndex.shift();
  return indexIntoObj(newIndex, obj[first]);
};
var totalReducer = exports.totalReducer = function totalReducer(value) {
  return function (cume, current) {
    var currVal = dotIndex(value, current);
    if (Number.isNaN(currVal)) {
      return cume;
    }
    return cume + Number(currVal);
  };
};
var setPrecision = exports.setPrecision = function setPrecision(value, precision) {
  var newValue = Number.isNaN(value) ? null : +Number.parseFloat(value).toFixed(precision);
  return Number.isNaN(newValue) ? null : newValue;
};
var shorten = exports.shorten = function shorten(string, maxLength, tailLength) {
  if (typeof string !== 'string') {
    return string;
  }
  var max = ifUndefined(maxLength, 40);
  var tail = ifUndefined(tailLength, 10);
  var len = string.length;
  if (len > max) {
    return string.slice(0, max - (tail + 3)) + '...' + string.slice(-tail);
  }
  return string;
};